import { useState, useEffect } from 'react';
import { getTranslations, type Translations } from '@deadpan/shared';

/**
 * Custom hook for translations that automatically updates when language changes
 */
export function useTranslations(): Translations {
  const [t, setT] = useState(getTranslations());

  useEffect(() => {
    const handleLanguageChange = () => {
      setT(getTranslations());
    };
    window.addEventListener('languagechange', handleLanguageChange);
    return () => window.removeEventListener('languagechange', handleLanguageChange);
  }, []);

  return t;
}

